// extracted by mini-css-extract-plugin
module.exports = {"deleteBut":"courses-module--deleteBut--3MTcn","course":"courses-module--course--3NDWD","freeblock":"courses-module--freeblock--3I9Bt","classes":"courses-module--classes--1mmvY"};